/**
 * CooIdentityRibbon.js — Slim charter ribbon shown on every COO-composed surface.
 * Reflects the verbatim charter locked in by CEO Shannon Ware.
 */
import React, { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CYAN = "#00CFCF"; const CHROME = "#A0A0A0"; const INK = "#F5F5F7";

export default function CooIdentityRibbon() {
  const [charter, setCharter] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/coo/charter`).then(r => r.json()).then(setCharter).catch(() => {});
  }, []);

  if (!charter) return null;

  return (
    <div
      data-testid="coo-identity-ribbon"
      style={{
        background: "linear-gradient(90deg, rgba(0,207,207,0.08), rgba(0,207,207,0.02))",
        border: `1px solid ${CYAN}44`,
        borderRadius: 10,
        padding: "10px 14px",
        marginBottom: 14,
        fontSize: 12,
        color: INK,
      }}
    >
      <div style={{ fontSize: 10, letterSpacing: "0.2em", color: CYAN, marginBottom: 4 }}>
        COO CHARTER · MOOVIN FORWARD LLC · ROI STABILIZATION FUND
      </div>
      <div style={{ color: INK, lineHeight: 1.5 }} data-testid="coo-charter-statement">
        {charter.identity_statement}
      </div>
      <div style={{ marginTop: 4, fontSize: 11, color: CHROME }}>
        Principal: {charter.principal}
      </div>
    </div>
  );
}
